import { ReactComponent as SliderIcon } from "../../assets/icons/sidebar/arrange-square.svg";
import { ReactComponent as ProjectsIcon } from "../../assets/icons/sidebar/folder-add.svg";
import { ReactComponent as ProjectsCategory } from "../../assets/icons/sidebar/folder-open.svg";
import { ReactComponent as ServicesIcon } from "../../assets/icons/sidebar/medal-star.svg";
import { ReactComponent as OurTeamIcon } from "../../assets/icons/sidebar/people.svg";
import { ReactComponent as SectionIcon } from "../../assets/icons/sidebar/security-user.svg";
import { ReactComponent as FeedbackIcon } from "../../assets/icons/sidebar/message-search.svg";
import { ReactComponent as NewsIcon } from "../../assets/icons/sidebar/receipt-item.svg";
import { ReactComponent as VacanciesIcon } from "../../assets/icons/sidebar/search-status.svg";
import { ReactComponent as NotificationsIcon } from "../../assets/icons/sidebar/messages.svg";
import { ReactComponent as Statistics } from "../../assets/icons/sidebar/statistics.svg";
import { FaRegHandshake } from "react-icons/fa";
import { LiaGlobeSolid } from "react-icons/lia";

export const sidebarItems = [
  {
    path: "/slider",
    title: "Slayder",
    icon: SliderIcon,
  },
  {
    path: "/stats",
    title: "Statistika",
    icon: Statistics,
  },
  {
    path: "/projects",
    title: "Loyihalar",
    icon: ProjectsIcon,
    // children: [
    //   {
    //     path: "Loyihalar",
    //     title: "/projects",
    //   },
    //   {
    //     path: "Kategoriya",
    //     title: "/projects-category",
    //   },
    // ],
  },
  {
    path: "/category",
    title: "Loyihalar kategoriyasi",
    icon: ProjectsCategory,
  },
  {
    path: "/services",
    title: "Xizmatlar",
    icon: ServicesIcon,
  },
  {
    path: "/ourteam",
    title: "Bizning jamoa",
    icon: OurTeamIcon,
    // children: [
    //   {
    //     path: "Jamoa a'zolari",
    //     title: "/ourteam",
    //   },
    //   {
    //     path: "Kategoriya",
    //     title: "/ourteam-category",
    //   },
    // ],
  },
  {
    path: "/section",
    title: "Bo'lim",
    icon: SectionIcon,
  },
  {
    path: "/feedback",
    title: "Mijozlar fikri",
    icon: FeedbackIcon,
  },
  {
    path: "/news",
    title: "Yangiliklar",
    icon: LiaGlobeSolid,
  },
  {
    path: "/blog",
    title: "Blog",
    icon: NewsIcon,
  },
  {
    path: "/customers",
    title: "Bizning mijozlar",
    icon: FaRegHandshake,
  },
  {
    path: "/vacancies",
    title: "Vakansiyalar",
    icon: VacanciesIcon,
    // children: [
    //   {
    //     path: "Vakansiyalar",
    //     title: "/vacancies",
    //   },
    //   {
    //     path: "Kategoriya",
    //     title: "/vacancies-category",
    //   },
    // ],
  },

  {
    path: "/contact-message",
    title: "Bog'lanish xabarlari",
    icon: NotificationsIcon,
  },
  {
    path: "/vacancy-message",
    title: "Vakansiya xabarlari",
    icon: NotificationsIcon,
  },
];
